import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `MovimientoVerraco`, method: 'GET', body: null, token: token})
}
